import { IProductionFiltersMetadata, RydeUiUnit } from "@ryde/shared";

export enum ProductionLogStatsTab {
  Produce = "Produce",
  Metrics = "Metrics",
  SystemParams = "SystemParams",
}

export interface IIdFilterItem {
  label: string;
  id: number;
}

export interface IIdLabeledFilterValue {
  entity: RydeUiUnit;
  items: IIdFilterItem[];
}

/** Bookings use id-only links; no dropdown labels are resolved or stored. */
export interface IIdsOnlyFilterValue {
  entity: RydeUiUnit;
  ids: number[];
}

export type IIdFilterValue = IIdLabeledFilterValue | IIdsOnlyFilterValue;

export type ResolvedFilterValue = string | IIdFilterValue;

export type TProductionMetricsFilterDisplayItem = {
  key: keyof IProductionFiltersMetadata;
  label: string;
};
